import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import "../styles/Login.css";
import logo from "../assets/a0b9f44cc8f2da963034bf8a0849385a074bd917.png";
import API_BASE_URL from ".././config/env";

const Login: React.FC = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Check if user is already logged in
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("auth") || 
                            localStorage.getItem("authToken") || 
                            localStorage.getItem("gp_token");
    if (isAuthenticated) {
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (phone.length !== 10) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Number",
        text: "Please enter a valid 10-digit mobile number",
      });
    }

    setLoading(true);

    try {
      const res = await axios.post(
        `${API_BASE_URL}/api/global-partner-send-otp`,
        { mobile_number: phone }
      );

      if (res.data.status === "success") {
        localStorage.setItem("gp_phone", phone);

        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: "Please enter the 4-digit OTP sent to your registered mobile number.",
          timer: 1500,
          showConfirmButton: false,
        });

        navigate("/otp");
      }
    } catch (err: any) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: err.response?.data?.message || "Failed to send OTP",
      });
    }

    setLoading(false);
  };

  return (
    <div className="container-fluid">
      <div className="login-wrapper">
        <div className="login-card">
          <img src={logo} alt="logo" className="logo" />

          <h2>Welcome Back</h2>
          <p className="sub-text">Sign in to your account</p>

          <form onSubmit={handleSubmit}>
            <label>Phone Number</label>
            <input
              type="tel"
              placeholder="Enter 10-digit number"
              value={phone}
              onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
              maxLength={10}
            />

            <button type="submit" disabled={loading}>
              {loading ? "Sending OTP..." : "Continue"}
            </button>
          </form>

          <p className="register-text">
            Don't have an account?{" "}
            <Link to="/register/form" className="link">Register</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;